import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {DatePipe, PercentPipe} from "@angular/common";

@Component({
  selector: 'pipelines-panel-pricing-details',
  imports: [
    PercentPipe,
    DatePipe
  ],
  templateUrl: './pipelines-panel-pricing-details.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./pipelines-panel-pricing-details.component.scss','../../pipelines-table.component.scss']
})
export class PipelinesPanelPricingDetailsComponent implements OnInit{
  @Input() detail: any;
  public expanded: boolean = false;
  public data:any;



  ngOnInit() {
    this.formatData()
  }

  public toggleExpand(){
    this.expanded = !this.expanded
  }

  private formatData(){
    this.data = {}
    let dates = this.detail.pricingDates;
    dates.forEach((date:any) => {
      if(date.dateType.name == 'Response to Developer Needed' || date.dateType.name == 'Placement Guidance Expiration' || date.dateType.name == 'Placement Guidance Issued'){
        this.data[date.dateType.name] = date.date;
      }
    })
  }

}
